/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-insurances
 * crm-screener-insurances
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface PalAuthSubmissionLeadFacility
 */
export interface PalAuthSubmissionLeadFacility {
    /**
     * 
     */
    name: string;
    /**
     * 
     */
    id: string;
}

/**
 * Check if a given object implements the PalAuthSubmissionLeadFacility interface.
 */
export function instanceOfPalAuthSubmissionLeadFacility(value: object): value is PalAuthSubmissionLeadFacility {
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('id' in value) || value['id'] === undefined) return false;
    return true;
}

export function PalAuthSubmissionLeadFacilityFromJSON(json: any): PalAuthSubmissionLeadFacility {
    return PalAuthSubmissionLeadFacilityFromJSONTyped(json, false);
}

export function PalAuthSubmissionLeadFacilityFromJSONTyped(json: any, ignoreDiscriminator: boolean): PalAuthSubmissionLeadFacility {
    if (json == null) {
        return json;
    }
    return {
        
        'name': json['name'],
        'id': json['id'],
    };
}

export function PalAuthSubmissionLeadFacilityToJSON(json: any): PalAuthSubmissionLeadFacility {
    return PalAuthSubmissionLeadFacilityToJSONTyped(json, false);
}

export function PalAuthSubmissionLeadFacilityToJSONTyped(value?: PalAuthSubmissionLeadFacility | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'name': value['name'],
        'id': value['id'],
    };
}

